import React from 'react';
import { Route } from 'react-router-dom';
import slug from 'constants/slug';
import FacilityeiaCreate from './FacilityeiaCreate';
import FacilityeiaEdit from './FacilityeiaEdit';
import FacilityeiaView from './FacilityeiaView';
import FacilityeiaList from './FacilityeiaList';

export default props => [
  <Route
    exact
    key={slug.FACILITY_EIA.LIST}
    path={slug.FACILITY_EIA.LIST}
    render={(matchProps) => (
      <FacilityeiaList {...matchProps} {...props}  />
    )}
  />,
  <Route
    key={slug.FACILITY_EIA.CREATE}
    path={slug.FACILITY_EIA.CREATE}
    render={matchProps => <FacilityeiaCreate {...matchProps} {...props} />}
  />,
  <Route
    key={slug.FACILITY_EIA.VIEW}
    path={slug.FACILITY_EIA.VIEW}
    render={matchProps => <FacilityeiaView {...matchProps} {...props} />}
  />,
  <Route
    key={slug.FACILITY_EIA.EDIT}
    path={slug.FACILITY_EIA.EDIT}
    render={matchProps => <FacilityeiaEdit {...matchProps} {...props} />}
  />
];



// WEBPACK FOOTER //
// ./src/containers/FacilityeiaContainer/index.js